function YYYYMMDDtoDDMMYYYY(YYYYMMDD) {
  const date = new Date(YYYYMMDD);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

module.exports = YYYYMMDDtoDDMMYYYY;
